
import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
import Cache from '../cache/cache';
export default async function goodCommentLevel(context: Context, params: CustomQuery): Promise<ApiResult> {
  const cacheKey = 'goodComment' + JSON.stringify(params);
  const cache = Cache.getCache(context, cacheKey);
  if (cache) {
    return cache;
  }
  const url = new URL('/mall/good/comment/level', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params);
  Cache.setCache(context, cacheKey, res, 1000 * 60 * 2);
  return res;
}
